import { createReducer } from '../../../app/common/util/reducerUtil';
import {
  CHANGE_ACTIVE_ROUTE
} from './SideBarConstants';

const initialState = {};

export const changeActiveRoute = (state, payload) => {
  return {
    ...state,
    activeRoute: payload
  }
}

export default createReducer(initialState, {
  [CHANGE_ACTIVE_ROUTE]: changeActiveRoute,
});